var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-popup"},[_c('vs-row',{staticClass:"content-popup pb-5 mb-5"},[_c('div',{staticClass:"col content-internal mb-5 pt-3",domProps:{"innerHTML":_vm._s(_vm.html)}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }